import { render, staticRenderFns } from "./FloatingBox.vue?vue&type=template&id=bcb04ff4&scoped=true"
import script from "./FloatingBox.vue?vue&type=script&lang=js"
export * from "./FloatingBox.vue?vue&type=script&lang=js"
import style0 from "./FloatingBox.vue?vue&type=style&index=0&id=bcb04ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb04ff4",
  null
  
)

export default component.exports